import { ChatModel } from "@/models/chat.model";

export enum ChatbotAction {
  COME_BACK_OBJECT = "come_back_object",
  NEXT_OBJECT = "next_object",
  LIKED_ACTION = "liked_action",
  CLIENT_CONFIGURED = "Client configured",
  IS_GPT = "chat_openai",
}

export enum QuestionType {
  QUESTION_WRONG = "open_questions_wrong",
  QUESTION_RANDOM = "open_questions_random",
}

export function checkMessage(message: any): ChatModel {
  var result: ChatModel = {
    message: "",
    options: [],
    type: "text",
    user: "homero",
    audio: "",
    show: false,
  };
  if (
    message &&
    message?.message != ChatbotAction.CLIENT_CONFIGURED &&
    !message?.error &&
    !message?.hasAction
  ) {
    result.message = message?.message;
    result.show = true;
  } else if (message.error) {
    result.message = "Não entendi, pode repetir?";
    result.show = true;
  }
  return result;
}

export var SpeechBubbleMsg = {
  default: {
    pt: "Estou por aqui caso você tenha qualquer dúvida.",
    en: "I'm here if you have any questions about the platform.",
  },
  tutorial: {
    pt: "<p>Lembre-se que você pode falar por áudio comigo, fale “Ajuda”, “Me ajude” ou “Preciso de ajuda”: <br><br> Ex.: “<b>Homero, me ajude</b>, tenho dúvidas em programação.”<br> <span class='ml-[32px]'>“<b>Homero, me ajude</b>, quero saber sobre o certificado do curso.”</span></p>",
    en: "<p>Remember that you can talk to me, start by saying my name: <br><br> Ex.:<br> “<b>Homero, help me</b>, I have doubts about programming.”<br> <span>“<b>Homero, help me</b>, I want to know about the course certificate.”</span></p>",
  },
  tutorial2: {
    pt: "<p>Qualquer dúvida que você tiver, clique aqui no chat ou use o áudio, é so falar o termo <b>“Ajuda...”</b>.</p>",
    en: "<p>Any questions you have, click here in the chat or use the audio, just say the term <b>“Help....”</b>.</p>",
  },
  tutorial3: {
    pt: "<p> Você pode falar comigo clicando aqui no chat ou falando por áudio. Para me chamar, fale o termo “Ajuda”. <br><br> Ex.: “<b>Me ajude</b>, quero aprender mais sobre a linguagem Swift.”</p>",
    en: "<p> You can talk to me by clicking here in the chat or speaking by audio. To summon me, say the term “Help”. <br><br> Ex.: “<b>Help me</b>, I want to learn more about the Swift language.”</p>",
  },
  QUESTION_RANDOM: {
    pt: "<p> Preparei uma pergunta para você, para relembrarmos os conteúdos que você viu.</p>",
    en: "<p> I prepared a question for you, so we can remember the content you saw.</p>",
  },
  QUESTION_WRONG: {
    pt: "<p>Você está se sentindo confiante sobre o que aprendeu no último objetivo? <b>Responda uma pergunta</b> para testar seus conhecimentos.</p>",
    en: "<p>Are you feeling confident about what you learned in the last objective? <b>Answer a question</b> to test your knowledge.</p>",
  },
};
